module.exports = __webpack_public_path__ + "static/media/bpmeasurex-5.fe5536ac.jpg";